module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/rewards/artillery-strike-elite-reward-50.3a88bef9.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/rewards/artillery-strike-elite-reward-50.png
// module id = 3775
// module chunks = 11